import {getEventDelay} from "./get-event-delay";
import {throttle} from "./throttle";
import {isInViewport} from "./is-In-viewport";

export function addAnimations() {
    let $win = $(window);
    let itemsGlobal = [];

    function addItems($items) {
        let items = $items || $(".has-animation");

        items.each(function () {
            itemsGlobal.push({
                $item: $(this),
                isAnimated: false
            });
        });
    }

    function run() {
        if (itemsGlobal.length) {
            $.each(itemsGlobal, function (index, item) {
                let $item = item.$item;

                if (isInViewport($item, -13)) {
                    item.isAnimated = true;
                    $item.addClass("animate");
                }
            });

            itemsGlobal = itemsGlobal.filter(function (item) {
                return !item.isAnimated;
            });
        }
    }

    $win.on("load", function () {
        addItems();
        run();

        ["scroll", "resize", "orientationchange"].map(function (item) {
            let eventDelay = getEventDelay(item);
            $win.on(item, throttle(run, eventDelay));
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/add-animations.js